import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { exhaustMap, map, mergeMap } from "rxjs";
import { UtilityService } from "../../services/utility/utility.service";
import { getNewEnquiryId, getNewEnquiryIdSuccess, getQuoteDetails, getQuoteDetailsSuccess, saveQuoteDetails, saveQuoteDetailsSuccess, selectPremium, selectPremiumSuccess, updateQuoteDetails, updateQuoteDetailsSuccess } from "./shared.action";
import { QuoteService } from "../../services/quote/quote.service";

@Injectable()
export class UtilityEffects {
    constructor(
        private actions$: Actions,
        private utilityService: UtilityService,
        private quoteService: QuoteService
    ) { }

    getQuoteDetails$ = createEffect(() =>{
        return this.actions$.pipe(
            ofType(getQuoteDetails),
            mergeMap((action) => {
                return this.utilityService.getPreQuoteData(action.enquiry_id).pipe(
                    map((data) => {
                        return getQuoteDetailsSuccess({ quote_details: data.pre_quote_data });
                    })
                );
            })
        );
    });

    savePreQuoteDetails$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(saveQuoteDetails),
            mergeMap((action) => {
                return this.utilityService.savePreQuoteData(action.quote_details).pipe(
                    map((data) => {
                        return saveQuoteDetailsSuccess({ enquiry_id: data.enquiry_id });
                    })
                );
            })
        );
    });
    
    updatePreQuoteDetails$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(updateQuoteDetails),
            mergeMap((action) => {
                return this.utilityService.updatePreQuoteData(action.enquiry_id, action.quote_details).pipe(
                    map((data) => {
                        return updateQuoteDetailsSuccess({ enquiry_id: data.enquiry_id });
                    })
                );
            })
        );
    });

    selectPremium$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(selectPremium),
            mergeMap((action) => {
                return this.quoteService.selectPremium(action.enquiry_id, action.insurer_id, action.plan_key, action.basic_info).pipe(
                    map((data) => {
                        return selectPremiumSuccess()
                    })
                )
            })
        )
    })
}
